module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesLuxury.cef7566.jpg";